import { FC } from 'react'
import { DeleteWithConfirmButton, SaveButton, Toolbar, useRecordContext, useTranslate } from 'react-admin'

interface OrgLinkEditToolbarProps {
  confirmContentKey: string
  tabPath: string
  orgIdField?: string
}

export const OrgLinkEditToolbar: FC<OrgLinkEditToolbarProps> = ({
  confirmContentKey,
  tabPath,
  orgIdField = 'organization_id',
}) => {
  const record = useRecordContext<Record<string, unknown>>()
  const translate = useTranslate()
  // eslint-disable-next-line security/detect-object-injection
  const orgId = record?.[orgIdField] as string | undefined
  const redirect = orgId ? `/organization/${orgId}/show/${tabPath}` : '/organization'

  return (
    <Toolbar>
      <SaveButton />
      <DeleteWithConfirmButton
        redirect={redirect}
        mutationMode="pessimistic"
        confirmTitle={translate('delete.confirmTitle')}
        confirmContent={translate(confirmContentKey)}
        sx={{ ml: 'auto' }}
      />
    </Toolbar>
  )
}
